import { gql, makeVar, type TypePolicies, useQuery } from '@apollo/client'
import { config } from '@backoffice-frontend/common'
import type { Region } from '@backoffice-frontend/graphql'

export const GET_SELECTED_REGION = gql`
  query getSelectedRegion {
    getSelectedRegion @client {
      id
      name
      operatorTenant
    }
  }
`

export const useGlobalRegion = (): [Region | undefined, boolean] => {
  const { data } = useQuery(GET_SELECTED_REGION)
  const loading = false

  return [data?.getSelectedRegion, loading]
}

export const selectedRegionVar = makeVar<Region | undefined>(config.getRegion())

export const selectRegion = (region?: Region) => {
  const currentRegion = selectedRegionVar()
  if (region?.id === currentRegion?.id) {
    return
  }

  config.setRegion(region)
  selectedRegionVar(region)
}

export const MoiaRegionTypePolicies: TypePolicies = {
  Query: {
    fields: {
      getSelectedRegion: {
        read(): Region | undefined {
          return selectedRegionVar()
        },
      },
    },
  },
}
